(() => {
  'use strict';

  const mobileToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!expanded));
      mobileMenu.hidden = expanded;
      document.body.classList.toggle('menu-open', !expanded);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mobileMenu.hidden) {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
        mobileToggle.focus();
      }
    });
  }

  document.querySelectorAll('[data-quantity-adjust]').forEach((button) => {
    button.addEventListener('click', () => {
      const field = button.parentElement.querySelector('input[type="number"]');
      if (!field) return;
      const current = Number.parseInt(field.value, 10) || 0;
      const next = current + Number.parseInt(button.dataset.quantityAdjust, 10);
      field.value = Math.max(Number.parseInt(field.min, 10) || 0, next);
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('[data-product-form]');
      if (!form || !option) return;
      const button = form.querySelector('[data-add-to-cart]');
      const price = document.querySelector('[data-product-price]');
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-thumbnail]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = document.querySelector('[data-product-main-image]');
      if (!image || !button.dataset.image) return;
      image.src = button.dataset.image;
      image.srcset = '';
      image.alt = button.dataset.alt || '';
      document.querySelectorAll('[data-thumbnail]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });
})();
